import React, { useState } from "react";

import "./SupportChat.css";

import {
    FaPaperPlane,
    FaPaperclip,
    FaSmile
} from "react-icons/fa";
import API from "../../../../../utils/apiCalling";
import { config } from "../../../../../utils/apiUrl";
import socket from "../../../../../socket/socket";

const SupportChat = ({
    selectedTicket,
    messages,
    setMessages,
    loadTickets,
    typing
}) => {
    const api = new API();
    const [message, setMessage] = useState("");

    const sendMessage = async () => {
        if (!message.trim()) return;
        try {
            const response = await api.post(
                config.adminReplay,
                {
                    ticketId: selectedTicket._id,
                    message
                }
            );
            if (response.status === "success") {
                setMessage("");
            }
        }
        catch (err) {
            console.log(err);
        }
    };

    if (!selectedTicket) {

        return (

            <div className="support-chat-empty">

                <img
                    src="https://cdn-icons-png.flaticon.com/512/1041/1041916.png"
                    alt=""
                />

                <h2>Select a Support Ticket</h2>

                <p>
                    Select any conversation from the left panel.
                </p>

            </div>

        );

    }
    const typingHandler = (e) => {
        setMessage(e.target.value);
        socket.emit("typing", {
            ticketId: selectedTicket._id,
            sender: "Admin"
        });
    };

    return (

        <div className="support-chat">

            {/* Header */}

            <div className="chat-header">

                <div className="chat-user">

                    <div className="chat-avatar">

                        {
                            selectedTicket.user?.fullName?.charAt(0)
                        }

                    </div>

                    <div>

                        <h3>

                            {
                                selectedTicket.user?.fullName
                            }

                        </h3>

                        <span>

                            Ticket :
                            {" "}
                            {
                                selectedTicket.ticketNumber
                            }

                        </span>

                    </div>

                </div>

                <div className="ticket-status">

                    <span
                        className={`status ${selectedTicket.status.toLowerCase()}`}
                    >

                        {
                            selectedTicket.status
                        }

                    </span>

                </div>

            </div>

            {/* Messages */}

            <div className="chat-messages">

                {/* <div className="message admin">

                    <div className="bubble">

                        Hello 👋

                    </div>

                </div>

                <div className="message user">

                    <div className="bubble">

                        Hi Sir

                    </div>

                </div>

                <div className="message admin">

                    <div className="bubble">

                        How can I help you?

                    </div>

                </div> */}

                {
                    messages.map((msg) => (

                        <div

                            key={msg._id}

                            className={`message ${msg.senderType === "Admin"
                                ? "admin"
                                : "user"
                                }`}

                        >

                            <div className="bubble">

                                {msg.message}

                            </div>

                        </div>

                    ))
                }

            </div>

            {/* Footer */}

            <div className="chat-footer">

                <button>

                    <FaSmile />

                </button>

                <button>

                    <FaPaperclip />

                </button>

                <input
                    value={message}
                    placeholder={
                        typing && (
                            <div className="typing-indicator">
                                User is typing...
                            </div>
                        )
                    }
                    onChange={typingHandler}
                    onKeyDown={(e) => {

                        if (e.key === "Enter") {

                            sendMessage();

                        }

                    }}
                />

                <button
                    className="send-btn"
                    onClick={sendMessage}
                >

                    <FaPaperPlane />

                </button>

            </div>

        </div>

    );

};

export default SupportChat;